export default String.raw`
.products-list.with-grid-view{
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
}

.product-item__coupons-container {
    margin: 8px 0;
    
    .show-more-coupons-product-list {
        @include body-1-regular;
        text-decoration: underline;
    }
}

`